module.exports = __webpack_public_path__ + "img/2.cebd4e73.jpg";